import { SVGProps } from 'react';

export default function InjuryIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="26"
      height="25"
      viewBox="0 0 26 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_9170_6275)">
        <path
          d="M13.0003 10.4173C15.3024 10.4173 17.167 8.55273 17.167 6.25065C17.167 3.94857 15.3024 2.08398 13.0003 2.08398C10.6982 2.08398 8.83366 3.94857 8.83366 6.25065C8.83366 8.55273 10.6982 10.4173 13.0003 10.4173ZM13.0003 4.16732C14.1462 4.16732 15.0837 5.10482 15.0837 6.25065C15.0837 7.39648 14.1462 8.33398 13.0003 8.33398C11.8545 8.33398 10.917 7.39648 10.917 6.25065C10.917 5.10482 11.8545 4.16732 13.0003 4.16732ZM19.6566 13.084C17.9066 12.1882 15.6357 11.459 13.0003 11.459C10.3649 11.459 8.09408 12.1882 6.34408 13.084C5.30241 13.6152 4.66699 14.6882 4.66699 15.8548V22.9173H6.75033V15.8548C6.75033 15.459 6.95866 15.1048 7.29199 14.9382C8.53158 14.3027 10.5316 13.5423 13.0003 13.5423C13.792 13.5423 14.5316 13.6152 15.2191 13.7507L13.6045 17.1882H10.6566C9.07324 17.1882 7.79199 18.4694 7.79199 20.0527C7.79199 21.6361 9.07324 22.9173 10.6566 22.9173H12.9274H19.2503C20.3962 22.9173 21.3337 21.9798 21.3337 20.834V15.8548C21.3337 14.6882 20.6982 13.6152 19.6566 13.084ZM11.8962 20.834H10.6566C10.2295 20.834 9.87533 20.4798 9.87533 20.0527C9.87533 19.6257 10.2295 19.2715 10.6566 19.2715H12.6253L11.8962 20.834ZM19.2503 20.834H14.1982L17.2607 14.3027C17.8232 14.5111 18.3128 14.7298 18.7191 14.9382C19.042 15.1048 19.2503 15.459 19.2503 15.8548V20.834Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_9170_6275">
          <rect width="25" height="25" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
}
